import React from 'react'
import logo from '../logo-text.png'

const PrivacyPolicy = () => (
    <>
    <div className="level-item">
    <img src={logo} alt="Logo" style={{width: 400, height: 400, marginBottom: '-2.5%'}}/>
    </div>
    <h1 className="is-size-1">Our Privacy Policy</h1>
    <h2 className="is-size-2">1. Introduction</h2>
    <p className="is-size-3">
        Clusterfy is a website that aims to simplify the studying process by clustering topics and providing collaborative tools for students to use with each other
    </p>
    <p className="is-size-3">
        This Privacy Policy applies whenever you use our services for “clusterfy.herokuapp.com” and "clusterfy.netlify.app" The Privacy Policy also entails the following:
    </p>
    <ul>
        <li>
           <p className="is-size-3">What information we collect</p>
        </li>
        <li>
            <p className="is-size-3">How we use the information</p>
        </li>
        <li>
            <p className="is-size-3">Who can use our website</p>
        </li>
    </ul>
    <h2 className="is-size-2">2. Information we collect and use</h2>
    <p className="is-size-3">
        We use your Personal Information only for providing and improving the Site.
    </p>
    <p className="is-size-3"> By using the site, site meaning “Clusterfy.herokuapp.com”, you agree to the collection and use of information in accordance with this policy. </p>
    <p className="is-size-3">Information You Provide For us: username you create when using the site, password to protect your account, names of study sets, info you provide for the flashcards created in a study set, date of birth to confirm you are 13+</p>
    <p className="is-size-3">We do not save the chats that you send in anyway</p>
    <p className="is-size-3">Information that is always collected: cookies so the site can identify that you are logged in when using</p>
    <h2 className="is-size-2">3. How we use your data</h2>
    <p className="is-size-3">We use your birthday to know that you are 13+ and meet age requirements to use the site safely, but will never store it</p>
    <p className="is-size-3">We display the content you post for others to see publicly</p>
    <p className="is-size-3">Display your username for others to see</p>
    <p className="is-size-3">We do not and will not sell your information to third party services or advertisers</p>
    <h2 className="is-size-2">4. Contact</h2>
    <p className="is-size-3">When you email us, we use your email to reply back and thank you for your question or concern. 
    </p>
    <p className="is-size-3">After the first reply, we will not use your email to send you spam mail, or any unauthorized message. 
    </p>
    <p className="is-size-3">We will not share the email exchange with anyone and or sell any information you provide
    </p>
    <h2 className="is-size-2">5. Community Guidelines</h2>
    <p className="is-size-3">A post cannot display nudity or offensively/menacingly target a specific group or anything threatening</p>
    <p className="is-size-3">We can revise and delete a post that violates these guidelines
    </p>
    <h2 className="is-size-2">6. Cookies</h2>
    <p className="is-size-3">What are cookies? Cookies are downloaded information to your computer or mobile phone
    </p>
    <h5 className="is-size-4">Required Cookies</h5>
    <p className="is-size-5">We use a session cookie in order to check whether or not you are logged in our site or not.
    </p>
    <h2 className="is-size-2">7. Future Updates to this Privacy Policy</h2>
    <p className="is-size-3">Please note that we can update this privacy policy at any time. You will be notified if we do so. You will be notified 30 days prior to the changes taking effect.
    </p>

    </>
)

export default PrivacyPolicy